import React from 'react';
import PropTypes from 'prop-types';

import { I18n } from 'src/translations/i18n';
import { Checkbox, Grid, withStyles } from '@material-ui/core';

import FormControlLabel from '../../Form/FormControlLabel';

const styles = () => ({
  disabled: {
    opacity: 0.6,
    pointerEvents: 'none'
  }
});

function CheckBox({
  checked, label, onChange, mouseInKey, isRequired, className, noTranslatedTitle, disabled, classes, titleLeft, placement, checkContainer
}) {
  return (
    <Grid item>
      <Grid
      container
      direction={titleLeft ? 'row-reverse' : 'row'}
      justifyContent={titleLeft ? 'flex-end' : 'flex-start'}
      alignItems="center"
      className={`${className} ${disabled ? classes.disabled : ''}`}
      onClick={onChange}
    >
        <Grid item className={checkContainer}>
          <Checkbox checked={checked} style={{ padding: 3 }} />
        </Grid>
        {label && (
        <FormControlLabel
          title={noTranslatedTitle ? label : I18n.t(label)}
          mouseInKey={mouseInKey}
          isRequired={isRequired}
          placement={placement}
        />
        )}
      </Grid>
    </Grid>
  );
}

CheckBox.propTypes = {
  classes: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  mouseInKey: PropTypes.string,
  className: PropTypes.string,
  checkContainer: PropTypes.string,
  placement: PropTypes.string,
  isRequired: PropTypes.bool,
  noTranslatedTitle: PropTypes.bool,
  titleLeft: PropTypes.bool,
  disabled: PropTypes.bool
};

CheckBox.defaultProps = {
  label: '',
  mouseInKey: '',
  className: '',
  checkContainer: '',
  placement: 'top',
  isRequired: false,
  disabled: false,
  noTranslatedTitle: false,
  titleLeft: false
};

export default withStyles(styles)(CheckBox);
